import { c as _c } from "react/compiler-runtime";
import { Toast, ToastClose, ToastDescription, ToastProvider, ToastTitle, ToastViewport } from "@/lib/components/toast";
import { useToast } from "@/lib/components/use-toast";
export function Toaster() {
  const $ = _c(5);
  const {
    toasts
  } = useToast();
  let t0;
  if ($[0] !== toasts) {
    t0 = toasts.map(_temp);
    $[0] = toasts;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ToastViewport />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t0) {
    t2 = <ToastProvider>{t0}{t1}</ToastProvider>;
    $[3] = t0;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}
function _temp(t0) {
  const {
    id,
    title,
    description,
    action,
    ...props
  } = t0;
  return <Toast key={id} {...props} className={props.variant === "destructive" ? "text-white" : ""}><div className="grid gap-1">{title && <ToastTitle>{title}</ToastTitle>}{description && <ToastDescription>{description}</ToastDescription>}</div>{action}<ToastClose /></Toast>;
}